import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServiceRequired = _resolveComponent("ServiceRequired")!
  const _component_PatientDiagnosis = _resolveComponent("PatientDiagnosis")!
  const _component_ClinicalComments = _resolveComponent("ClinicalComments")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ServiceRequired, {
      "account-id": _ctx.accountId,
      "referral-options": _ctx.referralOptions,
      onUpdateServicesRequired: _ctx.updateServicesRequired
    }, null, 8 /* PROPS */, ["account-id", "referral-options", "onUpdateServicesRequired"]),
    _createVNode(_component_PatientDiagnosis, { class: "mt-2" }),
    _createVNode(_component_ClinicalComments, { class: "mt-2" })
  ]))
}